angular
    .module('app')
    .factory('DownloadXmlExService', function (HttpHelper, $browser, $window, $httpParamSerializer, toastr) {
    let fac = {
        downloadXml: downloadXml,
        downloadZip: downloadZip,
        downloadSettlementFile: downloadSettlementFile,
        downloadClearingFile: downloadClearingFile,
        downloadTraceFile: downloadTraceFile,
    };
    let numTracesForRequest = function (traceSummaryRequest) {
        return HttpHelper.post('api/Download/NumTracesForRequest', traceSummaryRequest).then(function (response) {
            return response;
        });
    };
    function downloadXml(traceSummaryRequest) {
        // Copy traceSummaryRequest
        let tsr = angular.copy(traceSummaryRequest);
        tsr.Take = 0;
        // Find out if we have any traces
        numTracesForRequest(tsr).then(function (response) {
            if (response.data === 0) {
                toastr.warning('There are no traces for this request.');
                return;
            }
            // If we do then download them
            tsr.ConnectedUser = null; // user will be fetched on server-side as the request fails if SSO is turned on 
            // (sth to do with the server-side not being able to rightly deserialize the SingleSignOnDetails dictionary)
            let params = $.param(tsr);
            let url = 'api/Download/SessionXml?' + params;
            $window.location.href = url;
            // TODO: Create file name using request data
            toastr.info('XML file downloaded');
        });
    }
    function downloadZip(traceSummaryRequest) {
        // Copy traceSummaryRequest
        let tsr = angular.copy(traceSummaryRequest);
        tsr.Take = 0;
        // Find out if we have any traces
        numTracesForRequest(tsr).then(function (response) {
            if (response.data === 0) {
                toastr.warning('There are no traces for this request.');
                return;
            }
            // If we do then download them
            tsr.ConnectedUser = null; // same reason why it's done in downloadXml method above
            let params = $.param(tsr);
            let url = 'api/Download/SessionZip?' + params;
            $window.location.href = url;
            // TODO: Create file name using request data
            toastr.info('ZIP file downloaded');
        });
    }
    function downloadSettlementFile(id) {
        let url = 'api/Download/SettlementFile?settlementRecordId=' + id;
        $window.location.href = url;
        toastr.info('Settlement file downloaded started...');
    }
    function downloadClearingFile(id) {
        let url = 'api/Download/DownloadClearingFile?fileId=' + id;
        $window.location.href = url;
        toastr.info('Clearing file downloaded started...');
    }
    function downloadTraceFile(id) {
        let url = 'api/Download/DownloadTraceFile?fileId=' + id;
        $window.location.href = url;
        toastr.info('Trace file downloaded started...');
    }
    return fac;
});
